import(/* webpackMode: "eager" */ "/vercel/path0/app/charity/src/app/global-error.tsx");
